import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

interface State {
  isOpen: boolean;
  keyword: string;
  page: number,
  pageSize: number,
  sortBy: string,
  topicTagEntryIds: string[];
  prodTagEntryIds: string[];
  startTimestamp: number;
  endTimestamp: number;
  categoryId: string;
  authorId: string;
  dataType: number
}

const initialState: State = {
  isOpen: false,
  keyword: '',
  page: 1,
  pageSize: 10,
  sortBy: 'publishDate',
  topicTagEntryIds: [],
  prodTagEntryIds: [],
  startTimestamp: 0,
  endTimestamp: 0,
  categoryId: '',
  authorId: '',
  dataType: 1
}

const NAME = 'sortFilter';
export const sortFilterSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    changeIsOpen: (state, action) => {
      state.isOpen = action.payload;
    },
  
    changeKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    changePage: (state, action) => {
      state.page = action.payload;
    },
    changePageSize: (state, action) => {
      state.pageSize = action.payload;
    },
  
    changeTopicSelected: (state, action) => {
      state.topicTagEntryIds = action.payload;
    },
    changeProductSelected: (state, action) => {
      state.prodTagEntryIds = action.payload;
    },
    
    changeCategoryId: (state, action) => {
      state.categoryId = action.payload;
    },
    changeAuthorId: (state, action) => {
      state.authorId = action.payload;
    },
  
  
    changeStartTimestamp: (state, action) => {
      state.startTimestamp = action.payload;
    },
    changeEndTimestamp: (state, action) => {
      state.endTimestamp = action.payload;
    },
    changeSortBy: (state, artion) => {
      state.sortBy = artion.payload
    },
    changeDataType: (state, action) => {
      state.dataType = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload[NAME]
      }
    })
  }
})

export const {
  changeIsOpen,
  changeKeyword,
  changePage,
  changePageSize,
  changeTopicSelected,
  changeProductSelected,
  changeStartTimestamp,
  changeEndTimestamp,
  changeCategoryId,
  changeAuthorId,
  changeSortBy,
  changeDataType
} = sortFilterSlice.actions;
export default sortFilterSlice;
